import { Divider } from '@mui/material'
import Rating from '@mui/material/Rating'
import _ from 'lodash'
import React from 'react'
import { Link } from 'react-router-dom'
import { getProductUrl } from '../../urls'
import FormattedDate from '@components/FormattedDate'
import { useTranslation } from 'react-i18next'
import { hideUsername } from '../../utils/misc'

interface IFeedback {
  score: number
  siteSpecifics?: {
    pk?: number
    slug?: string
    name: string
  }
  userName: string
  title: string
  timeCreated: string
  comment: string
  url: string
  salesChannel?: {
    name: string
  }
}

interface IProps {
  feedback: IFeedback
}

const FeedbackDetails: React.FC<IProps> = ({ feedback }) => {
  const { t } = useTranslation()
  const spec = feedback?.siteSpecifics
  return (
    !_.isEmpty(feedback) && (
      <>
        <div className='review'>
          <div className='flex items-center flex-wrap w-full'>
            <div className={`review__author ${feedback.userName?.length > 2 ? 'mr-20' : ''}`}>
              {hideUsername(feedback.userName)}
            </div>
            <Rating name='read-only' value={feedback.score} size='large' readOnly />
          </div>

          <div className='review__content'>
            <div className='review__title'>{feedback.title}</div>
            <div className='review__date'>
              <FormattedDate value={feedback.timeCreated} />
            </div>
            <div className='review__comment'>{feedback.comment}</div>
            {spec && (
              <div className='review__product'>
                <Link to={getProductUrl(spec.slug, spec.pk)} className='shadow-link'>
                  {spec.name}
                </Link>
              </div>
            )}
            {feedback.salesChannel?.name && feedback.url && (
              <div className='review__link'>
                {t('originalLink', 'Original link')}:{' '}
                <a href={feedback.url} className='shadow-link' target='_blank' aria-label={feedback.url}>
                  {feedback.salesChannel.name}
                </a>
              </div>
            )}
          </div>
        </div>
        <div className='my-10'>
          <Divider />
        </div>
      </>
    )
  )
}

export default FeedbackDetails
